import React from 'react';

interface IIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const InsuranceIcon = (props: IIconProps) => {
  const { height = 24, width = 24, className } = props;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M18.5 19C18.5 19.7956 18.1839 20.5587 17.6213 21.1213C17.0587 21.6839 16.2956 22 15.5 22C14.7044 22 13.9413 21.6839 13.3787 21.1213C12.8161 20.5587 12.5 19.7956 12.5 19V12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5.42893 4.92893C3.55357 6.8043 2.5 9.34784 2.5 12H22.5C22.5 9.34784 21.4464 6.8043 19.5711 4.92893C17.6957 3.05357 15.1522 2 12.5 2C9.84784 2 7.3043 3.05357 5.42893 4.92893Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default React.memo(InsuranceIcon);
